// Centralized booking MODE router (B5.1 · updated B9).
// Modes: "embed" (the Google iframe) | "native" (the prepared native flow).
// HARD RULES:
//   • Production is ALWAYS "embed". "native" is NEVER returned in a production
//     build, regardless of input. The native flow is a SIMULATED demo (no CRM,
//     no real booking) and must never be presented to real users until a future
//     CRM integration is authorized.
//   • Missing, invalid, or errored configuration → safe default ("embed").
//
// B9 change: in NON-PRODUCTION the prepared PUBLIC experience is now "native",
// so every Free Call CTA (which all funnel through BookingContext →
// BookingRouter → this resolver) opens the native panel without needing a query
// param. An explicit ?bookingMode=embed still restores the iframe for preview,
// and ?bookingMode=native is also honoured. No public CTA is modified — this is
// the ONLY swap point.
//
// Reversion: ?bookingMode=embed forces the iframe in non-production with no
// deploy; reverting this file restores "embed" everywhere. There is still NO
// public CMS `booking.mode` field (schema change out of scope); a future flag
// could feed this resolver to enable native in production once a real adapter
// replaces the mock.

export const BOOKING_MODES = ["embed", "native"];
// Production default (unchanged): the real Google iframe. Never native in prod.
export const DEFAULT_BOOKING_MODE = "embed";
// B9 prepared public experience, non-production only.
export const NONPROD_PUBLIC_MODE = "native";

export function isNonProduction(nodeEnv = process.env.NODE_ENV) {
  return nodeEnv !== "production";
}

// `search` may be injected for testing; defaults to window.location.search.
export function resolveBookingMode({ nodeEnv = process.env.NODE_ENV, search } = {}) {
  try {
    // Never allow native in production, no matter what is requested.
    if (!isNonProduction(nodeEnv)) return DEFAULT_BOOKING_MODE;
    // Non-production: an explicit, valid override wins (embed or native)…
    const qs = search != null ? search : (typeof window !== "undefined" ? window.location.search : "");
    const requested = new URLSearchParams(qs || "").get("bookingMode");
    if (requested && BOOKING_MODES.includes(requested)) return requested;
    // …otherwise the prepared public experience is native (B9).
    return NONPROD_PUBLIC_MODE;
  } catch {
    return DEFAULT_BOOKING_MODE;
  }
}

export function isNativePrepEnabled(opts) {
  return resolveBookingMode(opts) === "native";
}
